import { Field } from './Field';
import { ISingleField } from './ISingleField';
import { ComparisonType } from './ComparisonType';

export class SingleBooleanField extends Field implements ISingleField<boolean> {
  public value: boolean;

  constructor(name: string, description: string, value: boolean = null, comparisonType: ComparisonType = null) {
    super(name, description, SingleBooleanField.typeName(), comparisonType);
    this.value = value;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.SingleBooleanField";
  }
}
